import { Component, Input, ViewChild } from "@angular/core";
import { GraphicsInfoTextField } from "../../../../domain/graphics-info";

@Component({
  selector: "icn-graphics-text",
  templateUrl: "./text.component.html",
  styleUrls: ["./text.component.scss"],
})
export class GraphicsTextComponent {
  @ViewChild("textInput") textInput;

  @Input()
  textField: GraphicsInfoTextField;

  @Input()
  isDynamicPromoGraphicInstance: boolean = false;

  isControlsActive = false;

  activeControl = "dynamic";

  insertDynamicField(dynamicField: string) {
    this.textField.text += dynamicField;
    this.textInput.nativeElement.focus();
  }
}
